/** @jsx isolateComponent */
import { Fragment } from 'react';
import { SizeType } from '@zapier/product-get-help/src/types';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Spacer } from '@zapier/design-system';
import Section from '../Section';
import Container from '../Container';

type HelloSectionProps = {
  /** Size to display. */
  size?: SizeType;
  //** Padding Top in pixels for the container */
  containerPaddingTop?: number;
  //** Padding Bottom in pixels for the container */
  containerPaddingBottom?: number;
  //** Padding Left in pixels for the container */
  containerPaddingLeft?: number;
  //** Padding Right in pixels for the container */
  containerPaddingRight?: number;
  /** Title */
  title: string;
  /** Detail text */
  detailText?: string;
};

/**
 * A component to consistent styling for the hello header at the top of some screens
 */

const HelloSection = ({
  size = 'small',
  title = '',
  detailText,
  containerPaddingTop = 0,
  containerPaddingBottom = 0,
  containerPaddingLeft = 0,
  containerPaddingRight = 0,
}: HelloSectionProps) => {
  return (
    <Container
      paddingBottom={containerPaddingBottom}
      paddingLeft={containerPaddingLeft}
      paddingRight={containerPaddingRight}
      paddingTop={containerPaddingTop}
    >
      <Section
        // Rebranded styles show this heading smaller than the others, so always use smallest size for this. Affects heading font size.
        size={size}
        title={title}
      >
        <Spacer height={detailText ? 10 : 20} />
        {detailText && (
          <Fragment>
            <p>{detailText}</p>
            <Spacer height={10} />
          </Fragment>
        )}
      </Section>
    </Container>
  );
};

export default HelloSection;
